module.exports = __webpack_public_path__ + "static/media/dineIn09142026.98cdf3fb.pdf";